namespace RioERP.Enquiry {
    export interface EnquiryProductsRow {
        Id?: number;
        EnquiryId?: number;
        ProductId?: number;
        IsActive?: boolean;
        EnquiryEnquiryName?: string;
        EnquiryCustomerId?: number;
        EnquiryEnquiryDate?: string;
        EnquiryEStatus?: number;
        EnquiryEmailId1?: string;
        EnquiryEmailId2?: string;
        EnquiryMobile1?: string;
        EnquiryMobile2?: string;
        EnquiryAddress1?: string;
        EnquiryAddress2?: string;
        EnquiryCity?: string;
        EnquiryStateId?: number;
        EnquiryPincode?: number;
        EnquiryCountry?: string;
        EnquiryFollowupDate?: string;
        EnquiryIsActive?: boolean;
        EnquiryInsertUserId?: number;
        EnquiryInsertDate?: string;
        EnquiryUpdateUserId?: number;
        EnquiryUpdateDate?: string;
        EnquiryHandledBy?: number;
        EnquiryEEnquiryMode?: number;
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace EnquiryProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ProductProductName';
        export const localTextPrefix = 'Enquiry.EnquiryProducts';
        export const lookupKey = 'Enquiry.EnquiryProducts';

        export function getLookup(): Q.Lookup<EnquiryProductsRow> {
            return Q.getLookup<EnquiryProductsRow>('Enquiry.EnquiryProducts');
        }
        export const deletePermission = 'Enquiry:EnquiryManagement:Modify';
        export const insertPermission = 'Enquiry:EnquiryManagement:Modify';
        export const readPermission = 'Enquiry:EnquiryManagement:View';
        export const updatePermission = 'Enquiry:EnquiryManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            EnquiryId = "EnquiryId",
            ProductId = "ProductId",
            IsActive = "IsActive",
            EnquiryEnquiryName = "EnquiryEnquiryName",
            EnquiryCustomerId = "EnquiryCustomerId",
            EnquiryEnquiryDate = "EnquiryEnquiryDate",
            EnquiryEStatus = "EnquiryEStatus",
            EnquiryEmailId1 = "EnquiryEmailId1",
            EnquiryEmailId2 = "EnquiryEmailId2",
            EnquiryMobile1 = "EnquiryMobile1",
            EnquiryMobile2 = "EnquiryMobile2",
            EnquiryAddress1 = "EnquiryAddress1",
            EnquiryAddress2 = "EnquiryAddress2",
            EnquiryCity = "EnquiryCity",
            EnquiryStateId = "EnquiryStateId",
            EnquiryPincode = "EnquiryPincode",
            EnquiryCountry = "EnquiryCountry",
            EnquiryFollowupDate = "EnquiryFollowupDate",
            EnquiryIsActive = "EnquiryIsActive",
            EnquiryInsertUserId = "EnquiryInsertUserId",
            EnquiryInsertDate = "EnquiryInsertDate",
            EnquiryUpdateUserId = "EnquiryUpdateUserId",
            EnquiryUpdateDate = "EnquiryUpdateDate",
            EnquiryHandledBy = "EnquiryHandledBy",
            EnquiryEEnquiryMode = "EnquiryEEnquiryMode",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
